'use client'

import { useCallback } from 'react'
import Image from 'next/image'
import { useSession } from 'next-auth/react'

import { extractTokenFromClientSession } from 'modules/customer'
import { RadioGroup, RadioItem } from 'shared/ui/RadioGroup'
import { isNilOrEmpty } from 'shared/utils/ramda'

import { PackingOption } from '../../../types'
import useQueryPackingOptions from '../queries/useQueryPackingOptions'

import styles from './CartPackingCost.module.scss'

interface CartPackingCostProps {
  selectedPackingOption: PackingOption | null
  onChange: (option: PackingOption) => void
  cartId: string
  token: string | undefined
}
export default function CartPackingCost({
  selectedPackingOption,
  onChange
}: CartPackingCostProps) {
  const session = useSession()
  const token = extractTokenFromClientSession(session)
  const { data: availablePackingOptions } = useQueryPackingOptions({
    token
  })

  const handleChange = useCallback(
    (optionId: string) => {
      const optionToSelect = availablePackingOptions?.find(
        option => option.id === optionId
      )

      if (optionToSelect) {
        onChange(optionToSelect)
      }
    },
    [availablePackingOptions, onChange]
  )

  if (
    isNilOrEmpty(availablePackingOptions) ||
    isNilOrEmpty(selectedPackingOption)
  ) {
    return null
  }

  return (
    <>
      <h3 className={styles.header}>
        <Image
          src='/static/icons/bag.svg'
          alt=''
          role='presentation'
          width={16}
          height={20}
        />
        <span>Opakowanie</span>
      </h3>
      <hr className={styles.hr} />
      <form noValidate className={styles.styledForm} aria-label='Opcje opakowań'>
        <RadioGroup
          name='packingOption'
          selectedValue={selectedPackingOption?.id || null}
          onChange={handleChange}
        >
          {availablePackingOptions?.map(option => (
            <RadioItem key={option.id} value={option.id}>
              <div className={styles.label}>{option.name}</div>
              <div
                className={styles.price}
                dangerouslySetInnerHTML={{
                  __html: option.price.gross.formatted || ''
                }}
              />
            </RadioItem>
          ))}
        </RadioGroup>
      </form>

      <hr className={styles.hr} />
    </>
  )
}
